module.exports = __webpack_public_path__ + "static/media/minus-circle-light.296db51b.svg";